const geolocation = {

	get: function() {
		return new Promise((resolve, reject) => {
			if ("geolocation" in navigator) {
				navigator.geolocation.getCurrentPosition((position) => {

					const query = {
						location: {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						}
					};
					
					// Temporary fix:
					// Uncaught TypeError: Cannot read property 'maps' of undefined
					try {
						const geocoder = new window.google.maps.Geocoder;
				        geocoder.geocode(query, (results, status) => {
							if (status == 'OK' && results[0]) {
								return resolve(results[0]);
							} 
				        });
					} catch(e) {
						return reject(); 
					}
			        
				});
			} else {
				return reject();
			}
		});

	}

};


export default geolocation

